module.exports = __webpack_public_path__ + "static/ficosec-1-385f2558226aec0a1a856bea468001c0.jpg";